export const noApplicationSelected = 'No application selected';
export const clientIdHeaderName = 'client-id';
